import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'
import { WeveButtonIcon } from '@weve/ui'

import { CopyIcon } from '@icons'

export default Vue.extend({
  name: 'WeveButtonIconCopy',
  functional: true,
  render(h, { data }) {
    return h(
      WeveButtonIcon,
      mergeData(data, {
        props: { label: 'Copy' },
      }),
      [h(CopyIcon)]
    )
  },
})
